import { render, staticRenderFns } from "./campaignCartTotal.vue?vue&type=template&id=2acbbb74&scoped=true&"
import script from "./campaignCartTotal.vue?vue&type=script&lang=js&"
export * from "./campaignCartTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acbbb74",
  null
  
)

export default component.exports